import { render, staticRenderFns } from "./ApiKeysPage.vue?vue&type=template&id=2c642834&scoped=true&"
import script from "./ApiKeysPage.vue?vue&type=script&lang=ts&"
export * from "./ApiKeysPage.vue?vue&type=script&lang=ts&"
import style0 from "./ApiKeysPage.vue?vue&type=style&index=0&id=2c642834&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c642834",
  null
  
)

export default component.exports